import '../../lang/i18n';
import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from "react";
import { useSetAtom } from "jotai";
import { toastAtom } from "../../jotai_state";
import CustomButton from "../../components/CustomButton";
import Api from "../../services/Api";
import {getLanguage} from "../../lang/helpers";

export default function AvailabilityOther() {

  const api = Api.getInstance();
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language)
  const [ahead, setAhead] = useState<number>(0);
  const [maxBooking, setMaxBooking] = useState<number>(1);
  const [bufferTime, setBufferTime] = useState<number>(0);
  const setGlobalToast = useSetAtom(toastAtom);

  useEffect(() => {
    api.get('coach/meeting_settings').then((result) => {
      setAhead(result.json.ahead)
      setMaxBooking(result.json.maxBooking)
      setBufferTime(result.json.bufferTime)
    })
  }, [])


  const save = () => {
    const data = {
      ahead: ahead,
      maxBooking: maxBooking,
      bufferTime: bufferTime,
    }
    api.post('coach/meeting_settings', data).then(() => {
      setGlobalToast({
        text: lang === 'sv' ? 'Sparade dina inställningar' : 'Saved your settings',
      });
    })
  }

  const timesAhead = [0, 1, 2, 4, 8, 24]
  const maxBookings = [1, 2, 3, 4, 5, 6, 7, 8]
  const bufferTimes = [0, 5, 10, 15, 20, 25, 30, 45]

  return (
    <>
      <p className="mt-6 text-lg font-medium">{t('time-before-booking')}</p>
      <p className="text-neutral-300">{t('time-before-booking-set')}</p>

      <select onChange={(e) => setAhead(parseInt(e.target.value))}
              className="mt-2 z-select" value={ahead}>
        {
          timesAhead.map(hours => {
            return (
              <option value={hours} key={"hours_" + hours}>{hours} {t('hours')}</option>
            )
          })
        }
      </select>

      <p className="mt-6 text-lg font-medium">{t('max-bookings')}</p>
      <p className="text-neutral-300">{t('max-bookings-set')}</p>

      <select onChange={(e) => setMaxBooking(parseInt(e.target.value))}
              className="mt-2 z-select" value={maxBooking}>
        <option value="0">{lang === 'sv' ? 'Inget maxantal' : 'No limit'}</option>
        {
          maxBookings.map(hours => {
            return (
              <option value={hours} key={"max_" + hours}>{hours}</option>
            )
          })
        }
      </select>

      <p className="mt-6 text-lg font-medium">{t('buffer-time')}</p>
      <p className="text-neutral-300">{t('buffer-time-set')}</p>

      <select onChange={(e) => setBufferTime(parseInt(e.target.value))}
              className="mt-2 z-select" value={bufferTime}>
        {
          bufferTimes.map(m => {
            return (
              <option value={m} key={"max_" + m}>{m} {t('minutes')}</option>
            )
          })
        }
      </select>

      <CustomButton onClick={() => save()} className="w-full mt-6">
        {t('save')}
      </CustomButton>
    </>
  )
};